export const DOCUMENT_VIEWING = [
  "id",
  "name",
  "createdBy",
  "signedBy",
  "Files",
  "description",
];
